import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { RadioGroup } from 'ui/styled'
import { Button } from 'antd'
import enumCollections from 'constants/enumCollections'

// function for displaying the most common options above the fold
const getWithCommonOptions = (sortedOptions, commonOptions) => {
  let optionsWithCommonItems = sortedOptions
  commonOptions.forEach((item, index) => {
    const optionIndex = optionsWithCommonItems.findIndex(
      option => option.key === item
    )
    if (optionIndex !== -1) {
      const arrWithoutOption = optionsWithCommonItems.filter(
        opt => opt.key !== item
      )
      optionsWithCommonItems = [
        ...arrWithoutOption.slice(0, index),
        optionsWithCommonItems[optionIndex],
        ...arrWithoutOption.slice(index)
      ]
    }
  })
  return optionsWithCommonItems
}

const SourceRadio = ({
  query,
  hideValues = new Set(),
  filterFn = () => true,
  commonOptions = [],
  ...props
}) => {
  const [isHidden, setIsHidden] = useState(true)

  const values = enumCollections[query]?.enumValues || []

  const enumValues = hideValues
    ? values.filter(value => !hideValues.has(value.name))
    : values
  // Enums have pairs of name and description. Currently searching by description.

  const options = enumValues.map(item => ({
    key: item.name,
    value: item.name,
    label: item.description,
    disabled: !filterFn(item)
  }))

  // Disabled items go to the end of the list
  const sortedOptions = [...options].sort((a, b) => {
    if (a.disabled === b.disabled) {
      return a.key.localeCompare(b.key)
    }
    return a.disabled ? 1 : -1
  })

  const newOptions = commonOptions
    ? getWithCommonOptions(sortedOptions, commonOptions)
    : sortedOptions
  const optionsToDisplay = isHidden ? newOptions.slice(0, 3) : newOptions

  return (
    <>
      <RadioGroup
        {...props}
        options={optionsToDisplay}
        style={{ flexDirection: 'column' }}
      />
      <Button type="link" onClick={() => setIsHidden(prev => !prev)}>
        {isHidden ? 'Show more' : 'Show less'}
      </Button>
    </>
  )
}

SourceRadio.propTypes = {
  filterFn: PropTypes.func,
  query: PropTypes.string.isRequired,
  commonOptions: PropTypes.arrayOf(PropTypes.string),
  hideValues: PropTypes.instanceOf(Set)
}

export default SourceRadio
